module.exports = __webpack_public_path__ + "assets/icons/ic_done-2883.svg";